import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "tenant" ? "/locataire" : "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "tenant" ? "/locataire" : "/admin");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || "Échec de connexion");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] grid-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-slate-900 p-10" data-testid="admin-login-page">
        <div className="w-12 h-12 bg-[#FFC107] border border-slate-900 flex items-center justify-center mb-6">
          <Lock className="w-5 h-5" strokeWidth={2.5} />
        </div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FFC107] mb-2">— Espace gestion</div>
        <h1 className="font-display font-black text-3xl mb-2">Connexion administrateur</h1>
        <p className="text-slate-500 text-sm mb-8">Immobilier Solaire — back-office</p>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2 block">Email</span>
            <input required type="email" value={email} onChange={e => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full border border-slate-900/20 px-4 py-3 font-mono text-sm focus:outline-none focus:border-slate-900" />
          </label>
          <label className="block">
            <span className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2 block">Mot de passe</span>
            <input required type="password" value={password} onChange={e => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full border border-slate-900/20 px-4 py-3 font-mono text-sm focus:outline-none focus:border-slate-900" />
          </label>
          {error && <div className="text-sm text-red-600 bg-red-50 border-l-4 border-red-600 p-3" data-testid="login-error">{error}</div>}
          <button disabled={loading} type="submit" data-testid="admin-login-submit"
            className="btn-brutal btn-brutal-solar w-full px-6 py-4 font-bold uppercase tracking-wider text-sm flex items-center justify-center gap-3 disabled:opacity-50">
            {loading ? "Connexion..." : "Se connecter"} {!loading && <ArrowRight className="w-4 h-4" />}
          </button>
        </form>
      </div>
    </div>
  );
}
